import React from 'react'
import styles from './EdofSection9.module.css'
const EdofSection9 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.titleDiv}><h3><b>LacriMass™</b> <br />Outside</h3></div>
            <div className={styles.container}>

                <div className={styles.LacrimasDiv}>
                    <img src='Images/Lacrimax-Graphic.svg' alt='Lacrimax-Graphic' loading="lazy" decoding="async" />
                </div>
                <div className={styles.descriptionDiv}>
                    <div className={styles.descriptionDiv1}><p><b>The LacriMass™ surface design</b> promotes a non-uniform tear film distribution across the lens surface, increasing tear film thickness in the peripheral zones and enhancing ocular surface protection where mechanical stress is highest</p></div>
                    <div className={styles.descriptionDiv2}></div>
                </div>
                <div className={styles.RightBar}>
                    <img src='/Images/LacriMass_img.webp' alt='LacriMass_img' />
                </div>
            </div>

        </div>
    )
}

export default EdofSection9
